import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '@core/auth.service';
import { CommonService } from '../modules/shared/services/common.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { appRoutingUrl } from '../enums/comman.enums';
import { environment } from '@environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly cs: CommonService,
    private readonly location: Location,
    private readonly router: Router
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.urlWithParams.includes('skipInterceptor=true')) {
      return next.handle(req);
    }
    const clonedRequest = req.clone();
    return next.handle(clonedRequest).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          if (event?.status === 401) {
            this.cs.logoutUser();
            return;
          }
          if(event.url && (event.url.includes('/users/users?host_name'))){
            const res = event.body;
            if(res?.data?.is_creator_logout && !this.authService.userContext?.fm_user){
              this.cs.logoutUser();
            }
          }
          if(event.url && (event.url.includes('/user_by_username'))) {            
            const res = event.body;
            if (res?.data?.is_suspended || res?.data?.is_paused) {
              this.cs.showSuspendedPage(this.cs.getUserId());
            } else if (this.isNotOnActivityHomeProfile(this.location.path()) && (res?.data?.is_private || (!environment.whiteLabelConfig && res?.data?.only_followers_can_access_content)) && !res?.data?.is_follower) {
              this.router.navigate(['', res?.data?.user_name]);
            }
          }
        }
      })
    );
  }

  isNotOnActivityHomeProfile(currentBrowserURL: string): boolean {
    return !([appRoutingUrl.DASHBOARD_ACTIVITY, appRoutingUrl.DASHBOARD_POSTS].some(path => currentBrowserURL?.includes(path)) || !currentBrowserURL?.slice(1)?.includes('/'));
  }
}
